
import Vue from 'vue'
import axios from 'axios'
import { FormUserType, ProgressNoteSummaryTS, Tag } from '../../types/Sapphire_dto';

const PatientDocumentationPopup = Vue.extend({        
    name: "patient-documentation-component",
            data: function () {
                return {
                    patientId: 0,
                    currentFormDocList: [] as ProgressNoteSummaryTS[],
                    formsList: [] as ProgressNoteSummaryTS[],
                    documentsList: [] as ProgressNoteSummaryTS[],
                    range: 30,
                    formUserTypes: [] as FormUserType[],
                    formTags: [] as Tag[],
                    selectedFormUserTypes: [] as FormUserType[],
                    selectedFormTags: [] as Tag[],
                    searchTextBox: '',
                    openPopup: false,
                    CategoryTags: [] as String[]
                };
            },
            mounted: function () {
                //mounted is an event in the lifecyle of a vue component
            },
            computed: {
                //no computeds yet
            },
            methods: {
                limitTags (count) {
                    return `and ${count} more`
                },
                limitTypes (count) {
                    return `and ${count} more`
                },
                async show(patID: number, tagIDs, typeIDs) {
                    this.currentFormDocList.splice(0);
                    this.documentsList.splice(0);
                    this.formsList.splice(0);
                    this.selectedFormUserTypes.splice(0);
                    this.selectedFormTags.splice(0);
                    this.searchTextBox = '';
                    this.range = 30;
                    this.patientId= patID;

                    await this.getFormTags(tagIDs);
                    await this.getFormUserTypes(typeIDs);

                    this.getPatientDocumentation();
                    this.openPopup = true;
                },
                close: function () {
                    this.openPopup = false;
               },
                incrementRange: function (direction) {
                    switch (direction) {
                        case '-':
                            this.range = this.range - 30;
                            this.getPatientDocumentation();
                            break;
                        case '+':
                            this.range = this.range + 30;
                            this.getPatientDocumentation();
                            break;
                        default:
                            //do nothing;
                    }
                },
                viewForm: function (form) {
                    if (form.IsDynamicForm) {
                        window.open('PatientFormResponseViewerPage.aspx?formId=' + form.ID, '_blank', 'toolbar=no,scrollbars=no,resizable=yes,menubar=no,status=no,titlebar=no,top=100,left=100,width=950,height=770,innerHeight=770,innerWidth=950');
                    }
                    if (form.IsStaticForm) {
                        var strWithUrl = "DocumentDownload.aspx?viewInBrowser=1&" + form.FormViewerURL;
                        window.open(strWithUrl, "_blank", "toolbar=no,scrollbars=no,resizable=yes,menubar=no,status=no,titlebar=no,top=5,left=0,width=1024,height=760,innerHeight=760,innerWidth=1024");
                    }
                },
                downloadForm: function (form) {
                    if (form.IsDynamicForm) {
                        var downloadURL = "DocumentDownload.aspx?" + form.DownloadDynamicFormURL;
                        window.open(downloadURL);
                    }
                    if (form.IsStaticForm) {
                        var strWithOutUrl = "DocumentDownload.aspx?" + form.FormViewerURL;
                        window.open(strWithOutUrl);
                    }
                },
                downloadRedactedForm: function (form) {
                    var redactedDownloadURL = "DocumentDownload.aspx?" + form.DownloadRedactedDynamicFormURL;
                    window.open(redactedDownloadURL);
                },
                launchNewForm: function (form) {
                    window.open(form.LaunchNewFormURL, '_blank', 'toolbar=no,scrollbars=no,resizable=yes,menubar=no,status=no,titlebar=no,top=100,left=1,width=1240,height=750,innerHeight=750,innerWidth=1240');
                    return false;
                },
                downloadDocument: function (document) {
                    var strWithOutUrl = "DocumentDownload.aspx?" + document.DownloadDocumentURL;
                    window.open(strWithOutUrl);
                },
                async getFormUserTypes(typeIDs) {
                    var response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetPatientFormUserTypesByFacilityTS");
                    this.formUserTypes.splice(0);
                    this.formUserTypes = JSON.parse(response.data.d);
                    if (typeIDs && typeIDs != '0') {
                        this.handlePreselectedUserTypes(typeIDs);
                    }
                },
                async getFormTags(tagIDs) {
                    var response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetAllTagsTS")
                    this.formTags.splice(0);
                    this.formTags = JSON.parse(response.data.d);      
                                            
                    if (tagIDs && tagIDs != '0') {
                        this.handlePreselectedTags(tagIDs);
                    }
                },
                searchPatDocumentationFormsLibrary: function () {
                    //if (substring.length <= 1) {
                    //    return;
                    //}

                    var tempList = [] as ProgressNoteSummaryTS[];

                    // tempList = $.grep(this.currentFormDocList, function (obj) {
                    //     return obj.Name.toLowerCase().indexOf(substring) !== -1;
                    // });
                    // dentalConditionList.filter(c => c.ToothID === index).map(obj => obj.Symbol)
                    tempList = this.currentFormDocList.filter(c => c.Name.toLowerCase().includes(this.searchTextBox.toLowerCase()));

                    this.documentsList.splice(0);
                    this.formsList.splice(0);

                    tempList.forEach((v) => {

                        if (v.IsDocument === true) {
                            this.documentsList.push(v);
                        } else {
                            this.formsList.push(v);
                        }
                    });
                },
                handleBtnGetFilteredFormsLibraryClick: function () {
                    this.searchTextBox = '';
                    this.getPatientDocumentation();
                },
                async getPatientDocumentation() {
                    const response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetPatientDocumentationByDateRange", {
                        patientID: this.patientId || 0,
                        range: this.range,
                        userTypes: JSON.stringify(this.selectedFormUserTypes),
                        tags: JSON.stringify(this.selectedFormTags)
                    });
                    
                        this.currentFormDocList.splice(0);
                        this.documentsList.splice(0);
                        this.formsList.splice(0);
                        this.currentFormDocList = JSON.parse(response.data.d);

                        this.currentFormDocList.forEach((v) => {
                            this.CategoryTags = v.ProgressNoteDelimitedList.split(',');

                            if (v.IsDocument === true) {
                                this.documentsList.push(v);
                            } else {
                                this.formsList.push(v);
                            }
                        });
                        //this.setPopupPosition();
                        // // eslint-disable-next-line no-undef
                        // ShowPopup(document.getElementById('patientDocumentationComponentDiv'));
                        // // eslint-disable-next-line no-undef
                        // tb_remove2();
                },
                // setPopupPosition: function () {
                //     var top = (window.height() - document.getElementById("#patientDocumentationComponentDiv").height()) / 2;
                //     document.getElementById("#patientDocumentationComponentDiv").offset({ top: top });
                // },
                handleAccordionClick: function (e) {
                    this.bindAccordion(e.currentTarget);
                },
                bindAccordion: function(element) {
                    // var fadeSpeed = 350;
                    
                    if (element.classList.contains('patientdocheader-show-me')) {
                        element.classList.remove('patientdocheader-show-me');
                        element.classList.add('patientdocheader-hide-me');
                        element.innerHTML = ('[ - ]');
                        let description = element.closest('li').querySelector('div.patientdocheader-description-container');
                        description.style.display = "block";
                        // fadeIn(description, 1000);
                        // element.closest('div').next('div.patientdocheader-description-container').fadeIn(fadeSpeed)
                    } else {
                        element.classList.remove('patientdocheader-hide-me');
                        element.classList.add('patientdocheader-show-me');
                        element.innerHTML = ('[ + ]');
                        let description = element.closest('li').querySelector('div.patientdocheader-description-container');
                        description.style.display = "none";
                        // element.closest('div').next('div.patientdocheader-description-container').fadeOut(fadeSpeed)
                    }
                },
                handlePreselectedTags: function (prefilterTagIds) {
          this.selectedFormTags.splice(0);

          var tagIds = prefilterTagIds.split(',');
          tagIds.forEach((v) => {
              const result = this.formTags.find(tag => tag.ID === Number(v));
              this.selectedFormTags.push(result);
          });
          
          return true;
      },
      handlePreselectedUserTypes: function (prefilterUserTypes) {
          this.selectedFormUserTypes.splice(0);

          var typeIds = prefilterUserTypes.split(',');
          typeIds.forEach((v) => {
              const result = this.formUserTypes.find(ut => ut.ID === Number(v));
              this.selectedFormUserTypes.push(result);
          });
          return true;
      }
    }
    });

    export type PatientDocumentationPopupRef = InstanceType<typeof PatientDocumentationPopup>;
    export default PatientDocumentationPopup;

    // function fadeIn(el, time) {
    //     el.style.opacity = 0;

    //     var last = +new Date();
    //     var newDate = +new Date();
    //     var tick = function () {
    //         el.style.opacity = +el.style.opacity + (newDate - last) / time;
    //         last = +new Date();

    //         if (+el.style.opacity < 1) {
    //             (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
    //         }
    //     };

    //     tick();
    // }
